<template>
  <div class="h-full preload-config">
    <el-card class="h-full">
      <div class="h-40px">
        <el-button
          type="primary"
          class="pull-right ml-10px"
          @click="save"
          :disabled="!$hasAccess('create')"
          >保存</el-button
        >
        <el-button
          type="primary"
          class="pull-right"
          @click="handleAdd"
          :disabled="!$hasAccess('create')"
          >新增</el-button
        >
      </div>
      <el-table :data="tableData" border class="mt-10px" height="calc(100% - 48px)">
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          prop="standardName"
          width="110"
          show-overflow-tooltip
          label="数据标准库"
        ></el-table-column>
        <el-table-column prop="configName" show-overflow-tooltip label="配置文件"></el-table-column>
        <el-table-column prop="docCode" show-overflow-tooltip label="文档编码"></el-table-column>
        <el-table-column prop="docName" show-overflow-tooltip label="文档名称"></el-table-column>
        <el-table-column prop="revision" width="60" label="版本"></el-table-column>
        <el-table-column prop="fileName" show-overflow-tooltip label="文件名"></el-table-column>
        <el-table-column prop="loadNum" width="100" label="预加载数量"></el-table-column>
        <el-table-column prop="loadingTimes" width="110" label="历史加载次数"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="handleEdit(scope.row)"
              :disabled="!$hasAccess('update')"
              >编辑</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click="deleteConfig(scope.row)"
              :disabled="!$hasAccess('delete')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="1300px"
      @close="handleClose"
    >
      <!-- 弹窗内容：左右布局 -->
      <div class="dialog-content">
        <!-- 左侧目录树 -->
        <div class="tree-container">
          <el-card class="tree-card--preload">
            <div slot="header">
              <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">目录树 </span>
            </div>
            <div class="tree-header flex">
              <selectStandardId
                ref="selectStandard"
                @updateStandardList="updateStandardList"
                @updateStandardId="updateStandardId"
                :selectStandardProps="{ width: 'w-170px' }"
              />
              <el-input
                v-model="treeKeyword"
                placeholder="搜索目录"
                size="small"
                clearable
                class="flex-1 mr-10px ml-10px"
                @keyup.enter.native="searchTree"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  size="small"
                  @click="searchTree"
                ></el-button>
              </el-input>
            </div>
            <div class="tree-content">
              <el-tree
                v-if="treeStandBy"
                ref="tree"
                :data="treeData"
                node-key="id"
                :props="{ label: 'name', children: 'childrens' }"
                :default-expand-all="defaultExpandAll"
                :default-expanded-keys="defaultExpandIds"
                :expand-on-click-node="false"
                :filter-node-method="filterTree"
                :highlight-current="true"
                @node-click="handleNodeClick"
                :loading="treeLoading"
              ></el-tree>
            </div>
          </el-card>
        </div>
        <!-- 右侧表单 -->
        <el-card class="form-container">
          <div class="tree-header flex">
            <el-input
              v-model="fileKeyWords"
              placeholder="请输入文件或文档名称"
              size="small"
              clearable
              class="flex-1 mr-10px"
              @keyup.enter.native="searchEditModelList"
            >
              <el-button
                :disabled="!$hasAccess('read')"
                slot="append"
                icon="el-icon-search"
                size="small"
                @click="searchEditModelList"
              ></el-button>
            </el-input>
          </div>
          <el-table
            row-key="id"
            ref="multipleTable"
            @selection-change="selectModelLists"
            :data="fileTableData"
            border
            class="mt-10px"
            height="calc(100% - 48px)"
          >
            <el-table-column type="selection" :reserve-selection="true" width="55">
            </el-table-column>
            <el-table-column
              prop="fileName"
              show-overflow-tooltip
              label="文件名称"
            ></el-table-column>
            <el-table-column
              prop="docName"
              show-overflow-tooltip
              label="文档名称"
            ></el-table-column>
            <el-table-column prop="revision" width="100" label="文档版本"></el-table-column>
            <el-table-column prop="loadNum" width="100" label="预加载数量">
              <template slot-scope="scope">
                <el-input-number
                  class="w-60px"
                  clearable
                  v-model="scope.row.loadNum"
                  :controls="false"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="loadingTimes" width="110" label="历史加载次数"></el-table-column>
          </el-table>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit" :disabled="!$hasAccess('create')"
          >保存</el-button
        >
        <el-button @click="handleClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { isEmpty } from 'lodash'
import ModelServer from '../services/modelServer'
import selectStandardId from '../../../components/selectStandardId'

export default {
  name: 'preloadConfig',
  components: {
    selectStandardId,
  },
  data() {
    return {
      tableData: [],
      // 弹窗相关状态
      dialogVisible: false,
      dialogTitle: '',
      // 表单数据
      formData: {
        standardLibrary: '',
        configFile: '',
        documentCode: '',
        documentName: '',
        version: '',
        fileName: '',
        preloadCount: 0,
        historyCount: 0,
        directoryId: '', // 新增目录ID字段
      },
      // 目录树相关状态
      standardList: JSON.parse(localStorage.getItem('standardList')) || [],
      currentStandardItemCode: '',
      standardDocumentCode: '',
      moduleConfig: {
        VUE_APP_STANDARD_ID: '',
        VUE_APP_CLASS_ID: '',
      },
      treeKeyword: '',
      treeLoading: false,
      treeData: [],
      currentTreeSelect: {},
      treeStandBy: true,
      defaultExpandAll: false,
      defaultExpandIds: [''],
      isTreeLazy: true,
      currentTreeData: [],
      fileKeyWords: '',
      fileTableData: [],
      // 选中的模型列表数据
      selectedModelLists: [],
      // 当前编辑的配置ID
      currentConfigId: '',
    }
  },
  computed: {},
  created() {
    // 初始化标准库数据
    if (this.standardList.length > 0) {
      this.initData(this.standardList[0].id)
    }
    this.findPreLoadLists()
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.treeData = []
        this.fileKeyWords = ''
        this.fileTableData = []
        this.selectedModelLists = []
        this.$refs.multipleTable.clearSelection()
        this.currentTreeData = []
        this.treeKeyword = ''
        this.currentConfigId = '' // 重置当前配置ID
      }
    },
  },
  methods: {
    deleteConfig(row) {
      this.$confirm('确认要删除此配置么?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await ModelServer.deleteModelConfig([row.configId])
        console.log(res, 'res-111')
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.findPreLoadLists()
        }
      })
    },
    // 新增按钮点击事件
    handleAdd() {
      this.dialogTitle = '新增'
      // 重置表单数据和状态
      this.currentConfigId = ''
      this.selectedModelLists = []
      this.fileKeyWords = ''
      this.currentTreeSelect = {}
      this.getSearchTreeNode()
      this.dialogVisible = true
      this.$nextTick(() => {
        const standardId = this.$refs.selectStandard.standardList[0].id
        this.$refs.selectStandard.changeStandardId(standardId)
        this.$refs.selectStandard.standardId = standardId
      })
    },
    // 编辑按钮点击事件
    handleEdit(row) {
      const { standardId, folderId, configId } = row
      // 打开弹窗
      this.dialogVisible = true
      this.dialogTitle = '编辑'
      this.$nextTick(async () => {
        this.$refs.selectStandard.changeStandardId(standardId)
        this.$refs.selectStandard.standardId = standardId
        // 设置当前标准库ID和配置ID
        this.currentConfigId = configId

        // 加载目录树数据
        this.treeLoading = true
        this.treeStandBy = false

        // 获取目录树数据
        const res = await ModelServer.getTreeAllNodes({
          standardId: standardId,
          filter: '',
          isRoot: false,
          nodeId: '',
          fileType: 'pr',
        })

        this.treeLoading = false

        if (res && res.data && res.code === 0) {
          this.treeData = res.data
          this.treeStandBy = true

          // 在DOM更新后设置树的选中状态
          this.$nextTick(() => {
            if (this.$refs.tree && folderId) {
              // 设置当前选中的目录节点
              this.$refs.tree.setCurrentKey(folderId)

              // 查找并展开包含folderId的所有父节点
              const expandedIds = []
              const findParentNodes = (nodes, targetId) => {
                for (let node of nodes) {
                  if (node.id === targetId) {
                    return true
                  }
                  if (node.childrens && node.childrens.length) {
                    const found = findParentNodes(node.childrens, targetId)
                    if (found) {
                      expandedIds.push(node.id)
                      return true
                    }
                  }
                }
                return false
              }

              findParentNodes(this.treeData, folderId)
              this.defaultExpandIds = [...expandedIds, folderId]

              // 设置当前选中的节点数据
              this.currentTreeSelect = this.findNodeById(this.treeData, folderId) || {}

              // 加载该目录下的文件列表
              this.searchEditModelList()
            }
          })
        }
      })
    },
    // 根据ID查找节点
    findNodeById(nodes, targetId) {
      for (let node of nodes) {
        if (node.id === targetId) {
          return node
        }
        if (node.childrens && node.childrens.length) {
          const found = this.findNodeById(node.childrens, targetId)
          if (found) {
            return found
          }
        }
      }
      return null
    },
    // 初始化数据
    async initData(standardId) {
      const currentStandardItem = _.find(this.standardList, { id: standardId })
      if (currentStandardItem) {
        this.currentStandardItemCode = currentStandardItem.code
        this.standardDocumentCode = `${currentStandardItem.code}_Document.code`
        await this.updateStandardId(standardId)
      }
    },
    // 更新标准库列表
    updateStandardList(list) {
      this.standardList = list
      if (this.standardList.length > 0) {
        this.initData(this.standardList[0].id)
      }
    },
    // 更新标准库ID
    async updateStandardId(val) {
      this.treeLoading = true
      const currentStandardItem = _.find(this.standardList, ['id', val])
      if (currentStandardItem) {
        this.standardDocumentCode = `${currentStandardItem.code}_Document.code`
        this.moduleConfig.VUE_APP_STANDARD_ID = val
        this.getSearchTreeNode()
      }
      this.treeLoading = false
    },
    // 获取搜索节点
    async getSearchTreeNode() {
      this.isTreeLazy = false
      this.treeStandBy = false
      this.treeLoading = true
      const res = await ModelServer.getTreeAllNodes({
        standardId: this.moduleConfig.VUE_APP_STANDARD_ID, // 标准库id
        filter: this.treeKeyword, // 文档目录名称(模糊查询)
        isRoot: false, // 是否是根节点
        nodeId: '', // 当前节点id
        fileType: 'pr',
      })
      this.treeLoading = false
      if (res && res.data && res.code === 0) {
        this.treeData = res.data
        this.treeStandBy = true
        if (this.treeKeyword) {
          await this.expandMatchingNodes()
        }
      }
    },
    // 展开匹配节点
    async expandMatchingNodes() {
      await this.$nextTick()
      if (!this.treeData || !this.treeData.length) return

      const expandedIds = []
      const findAndCollectNodes = (nodes, parentIds = []) => {
        nodes.forEach((node) => {
          const currentIds = [...parentIds, node.id]

          if (this.filterTree(this.treeKeyword, node)) {
            currentIds.forEach((id) => {
              if (id && !expandedIds.includes(id)) {
                expandedIds.push(id)
              }
            })
          }

          if (node.childrens && node.childrens.length) {
            findAndCollectNodes(node.childrens, currentIds)
          }
        })
      }

      findAndCollectNodes(this.treeData)
      this.defaultExpandIds = expandedIds

      this.treeStandBy = false
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    searchTree() {
      this.$refs.tree.filter(this.treeKeyword)
    },
    // 过滤树节点
    filterTree(value, data) {
      if (!value) return true
      return data.name.toLowerCase().includes(value.toLowerCase())
    },
    // 加载树数据
    async loadTreeData(node, resolve) {
      if (this.treeKeyword) {
        return
      }
      this.treeLoading = true
      const res = await ModelServer.getTreeAllNodes({
        standardId: this.moduleConfig.VUE_APP_STANDARD_ID, // 标准库id
        filter: this.treeKeyword, // 文档目录名称(模糊查询)
        isRoot: false, // 是否是根节点
        nodeId: '', // 当前节点id
        fileType: 'pr',
      })
      this.treeLoading = false
      if (res && res.data && res.code === 0) {
        resolve(res.data)
        return
      }
      resolve([])
    },
    // 节点点击事件
    handleNodeClick(data) {
      this.currentTreeSelect = data
      this.searchEditModelList()
    },
    async searchEditModelList() {
      const res = await ModelServer.getPreloadEditList({
        FolderId: this.currentTreeSelect.id,
        KeyWord: this.fileKeyWords,
        StandardId: this.moduleConfig.VUE_APP_STANDARD_ID,
        ConfigId: this.currentConfigId,
      })
      if (res.code === 0 && res.data) {
        this.fileTableData = res.data

        // 编辑模式下自动选中与currentConfigId匹配的数据行
        if (this.currentConfigId && res.data.length > 0) {
          // 先清空之前的选择
          this.selectedModelLists = []
          this.$nextTick(() => {
            // 查找匹配的行
            const matchedRow = res.data.find((row) => row.configId === this.currentConfigId)
            if (matchedRow && this.$refs.multipleTable) {
              // 选中匹配的行
              this.$refs.multipleTable.toggleRowSelection(matchedRow, true)
              // 更新选中列表
              this.selectedModelLists = [matchedRow]
            }
          })
        }
        setTimeout(() => {
          const tableContentWidth = $('.el-dialog__body .el-table__body').width()
          console.log(tableContentWidth, 'tableContentWidth')
          $('.el-dialog__body .el-table__header').width(tableContentWidth)
        }, 50)
      }
    },
    async findPreLoadLists() {
      const res = await ModelServer.getPreloadLists({
        standardId: '',
      })
      if (res.code === 0 && res.data) {
        this.tableData = res.data
      }
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
    },
    async save() {
      // 保存
      const requestData = {
        standardId: '',
        preLoads: this.tableData,
      }
      const res = await ModelServer.createModelConfig(requestData)
      if (res.code === 0) {
        this.findPreLoadLists() // 刷新列表数据
        this.$message.success('保存成功')
      }
    },
    // 提交表单
    async handleSubmit() {
      if (isEmpty(this.selectedModelLists)) {
        this.$message.warning('请选择要配置的模型')
        return
      }

      // 根据是否有currentConfigId决定是新增还是编辑
      const requestData = {
        standardId: this.moduleConfig.VUE_APP_STANDARD_ID,
        preLoads: this.selectedModelLists,
      }

      const res = await ModelServer.createModelConfig(requestData)

      if (res.code === 0) {
        this.$message.success(this.currentConfigId ? '编辑成功' : '新增成功')
        this.dialogVisible = false
        this.findPreLoadLists() // 刷新列表数据
      }
    },
    // 表格选择事件处理
    selectModelLists(selection) {
      this.selectedModelLists = selection
      console.log('选中的模型列表:', this.selectedModelLists)
    },
  },
}
</script>

<style lang="scss" scoped>

.width-60px {
  ::v-deep .el-input {
    width: 60px;
  }
}
.dialog-content {
  display: flex;
  gap: 20px;
  height: 500px;
}

.tree-container {
  width: 450px;
  flex-shrink: 0;
}

.tree-card--preload {
  height: 100%;
  display: flex;
  flex-direction: column;
  .tree-content {
    height: calc(1000% - 40px);
    overflow-y: auto;
  }
}

.tree-header {
  margin-bottom: 10px;
}

.tree-search {
  width: 100%;
}

.tree-content {
  flex: 1;
  overflow: auto;
}

.form-container {
  flex: 1;
  overflow: auto;
}

/deep/ .el-card__body {
  height: 100%;
}

</style>
